import {useEffect, useState} from 'react';
import { createPortal } from 'react-dom';
import {isAfter, parseISO} from "date-fns";

export default function MessagePrompt({ visible, setVisible, onProceed }) {
    useEffect(() => {
        if (visible) {
            document.body.style.overflowY = 'hidden';
            document.body.style.overflowX = 'hidden';
        } else {
            document.body.style.overflowY = '';
        }
        return () => {
            document.body.style.overflowY = '';
        };
    }, [visible]);

    if (!visible) return null;
    return createPortal(
        <div style={overlayStyle}>
            <div style={modalStyle}>
                <button style={closeButtonStyle} onClick={() => setVisible(false)}>
                    &times;
                </button>
                <h2 style={titleStyle}>A Note for Our International Customers</h2>
                <p style={messageStyle}>Please note that although we offer free international shipping, your local
                    customs office may charge additional import duties, taxes, or fees before delivery. These costs are
                    not covered by Vieunite and must be paid by the recipient. Please check with your local customs
                    authority if you're unsure what charges may apply.</p>
                <button
                    style={okButtonStyle}
                    onClick={() => {
                        setVisible(false)
                        onProceed();
                    }}
                >
                    PROCEED
                </button>
            </div>
        </div>,
        document.body
    );
}

const overlayStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.6)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 9998,
};

const modalStyle = {
    backgroundColor: 'white',
    padding: '45px',
    borderRadius: '12px',
    maxWidth: '800px',
    width: '80%',
    display: 'flex',
    flexDirection: 'column',
    // justifyContent: 'center',
    alignItems: 'center',
    position: 'relative',
    boxShadow: '0 0 20px rgba(0,0,0,0.3)',
};

const titleStyle = {
    fontSize: '20px',
    fontWeight: 'bold',
    marginBottom: '15px',
    color: '#333',
};

const messageStyle = {
    fontSize: '16px',
    lineHeight: '1.5',
    color: '#666',
    marginBottom: '20px',
};

const okButtonStyle = {
    padding: '8px 30px',
    backgroundColor: '#105B63',
    color: 'white',
    border: 'none',
    borderRadius: '5px',
    cursor: 'pointer',
    fontSize: '16px',
};

const closeButtonStyle = {
    position: 'absolute',
    top: '12px',
    right: '12px',
    width: '32px',
    height: '32px',
    // borderRadius: '50%',
    backgroundColor: 'white',
    border: '1px solid #fff',
    fontSize: '25px',
    // fontWeight: 'bold',
    // color: '#333',
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    // boxShadow: '0 2px 4px rgba(0, 0, 0, 0.2)',
};